import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Strike from '@tiptap/extension-strike';
import Link from '@tiptap/extension-link';
import { Box } from '@mui/material';
import { useEffect } from 'react';

interface RenderRichTextProps {
    jsonContent: any;
}

export const RenderRichText: React.FC<RenderRichTextProps> = ({ jsonContent }) => {
    const richTextStyles = {
        '& .ProseMirror': {
          padding: 0,
          margin: 0,
          lineHeight: 1.5,
        },
        '& .ProseMirror p': {
          margin: 0,
          padding: 0,
        },
        '& .ProseMirror ul, & .ProseMirror ol': {
          margin: 0,
          paddingLeft: '1.25rem', // adjust as needed
        },
        '& .ProseMirror h1, & .ProseMirror h2, & .ProseMirror h3': {
          margin: 0,
        },
    };

    const editor = useEditor({
        editable: false,
        extensions: [
            StarterKit,
            Underline,
            Strike,
            Link.configure({ openOnClick: true }),
        ],
        content: jsonContent || '',
    });

    useEffect(() => {
      if (editor && jsonContent) {
          editor.commands.setContent(jsonContent);
      } else if (editor && !jsonContent) {
          editor.commands.clearContent();
      }
    }, [jsonContent, editor]);


    if (!editor) return null;

    return (
        <Box sx={richTextStyles}>
            <EditorContent editor={editor} />
        </Box>
    );
};
